export const productsConfig = {
    fields : [{
        type: 'textField',
        title: 'Trade Name',
        key: 'title',
        editable: true,
        name:'tradeName'
    },
    {
        type: 'textField',
        title: 'Manufacturer',
        key: 'Manufacturer',
        editable: true,
        name:'Manufacturer'
    },
    {
        type: 'textField',
        title: 'Ingredients',
        key: 'Ingredient',
        editable: true,
        name:'Ingredient'
    },
    {
        type: 'textField',
        title: 'Package Name',
        key: 'packageName',
        editable: true,
        name:'packageName'
    },
    
    {
        type: 'textField',
        title: 'Dosage Form',
        key: 'dosageForm',
        editable: true,
        name:'dosageForm'

    },
    {
        type: 'textField',
        title: 'Strength Per Unit',
        key: 'strengthPerUnit',
        editable: true,
        name:'strengthPerUnit'
    },
    {
        type: 'textField',
        title: 'Country of Origin',
        key: 'CountryOfOrigin',
        editable: true,
        name:'CountryOfOrigin'
    },
    {
        type: 'textField',
        title: 'Dispensing Mode',
        key: 'DispensingMode',
        editable: true,
        name:'DispensingMode'
    },
    {
        type: 'textField',
        title: 'Amounts',
        key: 'amounts',
        editable: true,
        name:'amounts'
    },
    {
        type: 'textField',
        title: 'Concentration Units',
        key: 'concentrationUnits',
        editable: true,
        name:'concentrationUnits'
    }
    ,
    {
        type: 'textField',
        title: 'Unit of Measure',
        key: 'unitOfMeasure',
        editable: true,
        name:'unitOfMeasure'
    },
    {
        type: 'textField',
        title: 'Package Size',
        key: 'packSize',
        editable: true,
        name:'packSize'
    },
    {
        type: 'textField',
        title: 'Package Details',
        key: 'packagingDetails',
        editable: true,
        name:'packagingDetails'
    },
    {
        type: 'textField',
        title: 'Primary Container Type',
        key: 'primaryContainerType',
        editable: true,
        name:'primaryContainerType'
    },
    {
        type: 'textField',
        title: 'Nature and Contents of Container',
        key: 'natureAndContentsOfContainer',
        editable: true,
        name:'natureAndContentsOfContainer'
    },
    {
        type: 'textField',
        title: 'Barcode Printed',
        key: 'barcodePrinted',
        editable: true,
        name:'barcodePrinted'
    },
    {
        type: 'textField',
        title: 'Gtin Number',
        key: 'gtinNumber',
        editable: true,
        name:'gtinNumber'
    },
    {
        type: 'textField',
        title: 'Decleration',
        key: 'decleration',
        editable: true,
        name:'decleration'
    },
    // {
    //     type: 'textField',
    //     title: 'Injectable Drug Delivery System',
    //     key: 'injectableDrugDeliverySystem',
    //     editable: true,
    //     name:'injectableDrugDeliverySystem'
    // },
    {
        type: 'textField',
        title: 'Delivery Lead Time',
        key: 'deliveryLeadTime',
        editable: true,
        name:'deliveryLeadTime'
    },
    {
        type: 'textField',
        title: 'Shelf Life',
        key: 'shelfLife',
        editable: true,
        name:'shelfLife'
    },
    {
        type: 'textField',
        title: 'Storage Condition',
        key: 'storageCondition',
        editable: true,
        name:'storageCondition'
    },

    {
        type: 'textField',
        title: 'Route of Adminstration',
        key: 'routeOfAdministration',
        editable: true,
        name:'routeOfAdministration'
    },
    {
        type: 'textField',
        title: 'Perservations',
        key: 'preservatives',
        editable: true,
        name:'preservatives'
    },
    {
        type: 'textField',
        title: 'Coloring Agents',
        key: 'coloringAgents',
        editable: true,
        name:'coloringAgents'
    },
    {
        type: 'textField',
        title: 'Sugar Type',
        key: 'sugarType',
        editable: true,
        name:'sugarType'
    },
    {
        type: 'textField',
        title: 'Sugar Free Formula',
        key: 'sugarFreeFormula',
        editable: true,
        name:'sugarFreeFormula'
    },
    {
        type: 'textField',
        title: 'Pork Derivatives Content',
        key: 'porkDerivativesContent',
        editable: true,
        name:'porkDerivativesContent'
    },
    {
        type: 'textField',
        title: 'Hormone Free Product',
        key: 'hormoneFreeProduct',
        editable: true,
        name:'hormoneFreeProduct'
    },
    {
        type: 'textField',
        title: 'Latex Free Product',
        key: 'latexFreeProduct',
        editable: true,
        name:'latexFreeProduct'
    },
    {
        type: 'textField',
        title: 'Gulten Free Product',
        key: 'gultenFreeProduct',
        editable: true,
        name:'gultenFreeProduct'
    },
    {
        type: 'textField',
        title: 'Certificate of Pharmaceutical Products',
        key: 'certificateOfPharmaceuticalProducts',
        editable: true,
        name:'certificateOfPharmaceuticalProducts'
    },
    {
        type: 'textField',
        title: 'Fda Registration',
        key: 'fdaRegistration',
        editable: true,
        name:'fdaRegistration'
    },
    {
        type: 'textField',
        title: 'Ema Registration',
        key: 'emaRgistration',
        editable: true,
        name:'emaRgistration'
    }
    
]
}